import React, { useState } from "react";
import { Menu, X } from "lucide-react"; // Icon library
import SvgLoader from "../utils/SVGLoader";

const logout = () => {} // Replace with actual logout function
const isLoggedIn = false; // Replace with actual login state

const AvatarOrLogin = ({ content }) => {
    const [open, setOpen] = useState(false);
    const handleToggle = () => setOpen(!open);

    return isLoggedIn ? (
        <div className="relative">
            {/* User Avatar */}
            <button
                className="w-8 h-8 rounded-full overflow-hidden border border-gray-300"
                onClick={handleToggle}
            >
                <img
                    src="/images/avatar.png"
                    alt="User Avatar"
                    className="w-full h-full object-cover"
                />
            </button>

            {/* User Dropdown */}
            {open && (
                <div className="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg z-50">
                    {/* Dropdown items */}
                    {content.navbar.userMenuItems.map((item, index) => (
                        <a key={index} href={item.item.path} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                            {item.item.label}
                        </a>
                    ))}
                    {/* Logout Button */}
                    <a
                        href="#logout"
                        onClick={() => {}} // Replace with actual logout function
                        className="block px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                    >
                        {content.navbar.logoutLabel}
                    </a>
                </div>
            )}
        </div>
    ) : (
        <div className="flex items-center space-x-2 cursor-pointer">
            {/* Avatar Placeholder */}
            <img
                src="/images/avatar.png"
                alt="User Avatar"
                className="object-cover w-7 h-7 rounded-full overflow-hidden border border-gray-300"
            />
            <a
                href="/login"
                className="no-underline !font-medium"
            >
                {content.navbar.loginLabel}
            </a>
        </div>
    );
};

const Logo = ({className, content}) => (
    <div className={`flex items-center space-x-2 ${className}`}>
        {/* Logo */}
        <SvgLoader url={content.logoSvgUrl} className="w-8 h-8 text-pf-darkGreen" />

        {/* Title */}
        <span className="font-semibold text-pf-darkGreen">{content.productName}</span>
    </div>
)

const Navbar = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const content = props.content || {};
    const page = props.page || "home";

    const Hamburger = () => (
        <button
            className="md:hidden"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
        >
            {isOpen ? <X className="text-pf-darkGreen" size={24} /> : <Menu className="text-pf-darkGreen" size={24} />}
        </button>
    );

    return (
        <nav className="navbar transition-all duration-500">
            <div className="wrapper h-full">
                {/* Left - Logo */}
                <div className="z-10 flex items-center space-x-2 ml-4">
                    <a href="/" className="cursor-pointer">
                        <Logo content={content} className="hidden md:flex" />
                        {/* Hamburger (Mobile Only) */}
                        <Hamburger />
                    </a>
                </div>

                <div className="md:absolute md:top-0 md:left-0 md:w-full md:h-full pf-container">
                    <div className="hidden md:flex items-center justify-center h-full space-x-8">
                        {/* Center - Nav Links (Desktop Only, homepage only) */}
                        {page === "home" && (
                            content.navbar.menuItems.map((item, index) => (
                                <a key={index} href={item.item.path}>{item.item.label}</a>
                            ))
                        )}
                        {page === "signup" && (
                            <h3>
                                {content.navbar.signupTitle}
                            </h3>
                        )}
                        {page === "my-account" && (
                            <h3>
                                {content.navbar.myAccountTitle}
                            </h3>
                        )}

                    </div>
                    {/* Center - Logo (Mobile Only) */}
                    <Logo content={content} className="flex md:hidden" />
                </div>

                {/* Right - avatar or login */}
                <div className="pf-container mr-4">
                    <AvatarOrLogin content={content} isLoggedIn={isLoggedIn} handleLogout={logout} />
                </div>
            </div>

            {/* Mobile Dropdown */}
            {isOpen && (
                <div className="md:hidden fixed top-16 left-1/2 transform -translate-x-1/2 w-[90%] bg-white shadow-lg rounded-xl p-6 z-40 space-y-4 flex flex-col items-center border border-gray-200">
                    {content.navbar.menuItems.map((item, index) => (
                        <a key={index} href={item.item.path}>{item.item.label}</a>
                    ))}
                </div>
            )}
        </nav>

    );
};

export default Navbar;
